import React from 'react';
import { DropZone } from './DropZone';
import strings from '../../resources/strings';
import consts from '../../resources/consts';
import './style.scss';

function AddImage(props: any) {
    const { text, text2, button1, button2, loading, errorMessage, successMessage, acceptedFormat } = strings.addFiles;
    const { maxFiles, maxSizeMB } = consts.addFiles;
    return (
        <DropZone
            isSendBtn={true}
            maxFiles={maxFiles}
            maxSizeMB={maxSizeMB}
            text={text}
            text2={props.fileType ? props.fileType : text2}
            button1={button1}
            button2={button2}
            loading={loading}
            errorMessage={errorMessage}
            successMessage={successMessage}
            acceptedFormat={props.acceptedFormat || acceptedFormat}
            path={props.path}
            setGetImgAddress={props.setGetImgAddress}
            sendOnDrop={props.sendOnDrop || false}
            customName={props.customName}
            showMessage={props.showMessage ?? true}
            actualEventId={props.actualEventId}
            actualEventFile={props.actualEventFile}
        />
    );
}

export default AddImage;
